export default {
      id: "butter-usage",
      viewBox: "0 0 31 16",
      url: __webpack_public_path__ + "img/icons.svg#butter",
      toString: function () {
        return this.url;
      }
    }